package ru.it_mozaika.sender.js.application.components.catalog

import mui.lab.TreeItem
import mui.lab.TreeView
import mui.material.*
import mui.system.sx
import react.*
import ru.it_mozaika.sender.common.models.Category
import ru.it_mozaika.sender.js.application.context.CategoriesContext
import web.cssom.*

external interface CatalogTreeDialogProps: Props{
    var isOpen :Boolean
    var onClose: () -> Unit
    var onSelect: (List<String>) -> Unit
}


val CatalogTreeDialog = FC<CatalogTreeDialogProps> { props ->
    val categoriesContext = useContext(CategoriesContext)
    val categories = categoriesContext.categories
    val parents = useMemo(categories){
        categories.filter { it.parent == null }
    }
    Dialog{
        sx{
            minWidth = 400.px
            overflowY = Auto.auto
//            width = 100.pct
//            position = Position.absolute
            paddingTop = 64.px

        }
//       fun buildTree(category: Category)  {
//            CatalogTreeItem{
//                this.buildTree = {children ->
////                    val children = props.categories.filter { it.parent == category.id }
//                    if (children.isNptEmpty) children.forEach { child -> buildTree(child) }
//
//                }
//                this.categories = props.categories
//                this.category = category
//            }
//
//        }
        open = props.isOpen
        DialogTitle{

            + if (categoriesContext.selected.isEmpty()) "Категории" else "Отмечено: ${categoriesContext.selected.size}"
        }
        Divider()
        DialogContent {

            TreeView {

                asDynamic().defaultCollapseIcon = mui.icons.material.RemoveCircleOutlineSharp.create{
                    color = SvgIconColor.secondary
                }
                asDynamic().defaultExpandIcon = mui.icons.material.ControlPointSharp.create{
                    color = SvgIconColor.secondary
                }
                    parents.forEach {
//                    buildTree(it)
                        CatalogTreeItem {
                            category = it
                        }
                    }
            }
        }
        Divider()
        DialogActions{
            sx{
                margin = 5.px
            }
            Button{
                +  "Отобрать"
                this.startIcon = mui.icons.material. DoneSharp.create()
                color = ButtonColor.secondary
                variant = ButtonVariant.outlined
                onClick = {
                    props.onSelect(categoriesContext.selectedIds)
                    props.onClose()
                }
            }
            Button{
                +  "Назад"
                color = ButtonColor.error
                variant = ButtonVariant.outlined
                this.startIcon = mui.icons.material.ArrowBackSharp.create()
                onClick = {
                    props.onClose()
                }
            }
        }
    }
}
fun ChildrenBuilder.buildTree(
    category: Category,
) {
    CatalogTreeItem {
        this.category = category
    }
}

external interface CatalogTreeItemProps: Props{
    var category: Category
    var buildTree: (List<Category>) -> Unit
}

val CatalogTreeItem:FC<CatalogTreeItemProps>  = FC<CatalogTreeItemProps>{props ->
    val categoriesContext = useContext(CategoriesContext)
    val categories = categoriesContext.categories
    var children by useState(emptyList<Category>())
    val allChildren = useMemo(categories, props.category.id){
        categoriesContext.getChildren(props.category.id)
    }

    val indeterminate = useMemo(categoriesContext.selected){
        allChildren
            .map { it.id }
            .intersect(categoriesContext.selectedIds
                .toSet())
            .isNotEmpty() && !categoriesContext.selectedIds.contains(props.category.id)
    }

    useEffect(props.category, categories) {
        children = categories.filter { it.parent == props.category.id }
    }

    TreeItem {

        nodeId = props.category.id
        label = FormControlLabel.create{
            label = ReactNode(props.category.name)
            control = Checkbox.create{
                checked = categoriesContext.selectedIds.contains(props.category.id) && !indeterminate
                this.indeterminate = indeterminate

                onClick = { event ->
                    categoriesContext.toggleId(props.category.id)
                    event.preventDefault()
                    event.stopPropagation()
                }
                color = CheckboxColor.secondary
            }
        }
        if (children.isNotEmpty()) children.forEach { buildTree(it) }
//        props.buildTree(children)

    }
}
